import * as React from "react";
import styled from "styled-components";
import { Colorable, select } from "@hubper/theme";
import Icon from "../../elements/Icon";

const Base = styled.div<Colorable>`
  width: 16px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: ${select.speed("fast")};
  background-color: ${p => {
    // @ts-ignore
    return select.findColorAlterIndex(p.c![0] === "grey" ? 2 : -1, p);
  }};
  border-radius: 50%;
  cursor: pointer;

  &:hover {
    background-color: ${p => {
      // @ts-ignore
      return select.findColorAlterIndex(p.c![0] === "grey" ? 3 : -2, p);
    }};
  }
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  onClick: () => void;
} & Colorable;

function DeleteButton({ style, className, c, onClick }: Props, ref: any) {
  return (
    <Base ref={ref} style={style} className={className} onClick={onClick} c={c}>
      <Icon
        size={8}
        name="cross"
        c={Array.isArray(c) && c[0] === "grey" ? ["grey", 1] : "white"}
      />
    </Base>
  );
}

export default React.forwardRef(DeleteButton);
